import { AJOList, AJOUpdater } from 'mp-js-react-auto-json-object';
import React from 'react';
import AppManager from '../../commun/AppManager';
import { Button } from '../../commun/component/Button';
import { get } from '../../commun/HTTP';
import Result from '../../commun/Result';
import { AddressModal } from '../../modal/addess/AddressModal';
import { AddElemVendorModal } from '../../modal/vendor/AddElemVendorModal';
import Address from '../../object/Address';
import Permission from '../../object/Permission';
import Prestation from '../../object/profile/Prestation';
import { JSXInternal } from 'preact/src/jsx';
import { IObjectSelectProps, IObjectSelectState, ObjectSelect } from './ObjectSelect';

export interface IPrestationSelectProps extends IObjectSelectProps<Prestation> {
    placeholder: string;
    prestationAjoList?: AJOList<Prestation>;
}

export class PrestationSelect extends ObjectSelect<Prestation, IPrestationSelectProps> {
    createGenericObject() {
        return Prestation;
    }
    constructor(props: IPrestationSelectProps) {
        /**
         * DEFAULT PROPS
         */

        super(props, Permission.MANAGE_CATEGORY, 'prestation');

        /**
         * CREATE STATE
         */
        this.state = this.initState();

        // FUNCTION USE TO NOTIFY PARENT COMPONENT
        this.state.ajoList.setUpdate(() => this.forceUpdate());
    }

    fetchList() {
        if (this.state.isAjoListInflate) {
            get('/prestation/list').then((res: any) => {
                if (Result.isSuccess(res)) {
                    Result.applyResult(res, this.state.ajoList, true);
                }
                this.setState({
                    isAjoListInflate: true,
                });
            });
        }
    }

    renderModal(): JSXInternal.Element {
        const { prestationAjoList } = this.props;
        const { elem } = this.state;
        let obj = this;
        return (
            <AddElemVendorModal
                mode="prestation"
                baseName={this.state.search}
                show={this.state.showModal}
                onCreate={(elem: any) => {
                    this.props.onObjectSelect(elem);
                }}
                handleClose={() => this.setState({ showModal: false })}
            />
        );
    }

    render(): JSXInternal.Element {
        AppManager.updater().add(this.state.ajoList);
        return super.render();
    }
}
